import { theme } from '@bpba/ui-components';
import styled from 'styled-components';
import { layout, LayoutProps, space, SpaceProps, flexbox, FlexboxProps, color, ColorProps } from 'styled-system';

export type SvgIconProps = {
  imageSvg?: string;
  color?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: string | number;
} & LayoutProps &
  SpaceProps &
  FlexboxProps;

export function SvgIcon(props: SvgIconProps) {
  function hasImage() {
    return Boolean(props.imageSvg);
  }
  const { imageSvg, ...otherProps } = props;
  const svgContent = imageSvg ? imageSvg : '';

  return <SvgContainer {...otherProps} dangerouslySetInnerHTML={{ __html: svgContent }} aria-hidden={hasImage()} />;
}

type SvgContainerProps = {
  fill?: string;
  stroke?: string;
  strokeWidth?: string | number;
} & LayoutProps &
  SpaceProps &
  FlexboxProps &
  ColorProps;

const SvgContainer = styled.div<SvgContainerProps>(
  layout,
  space,
  flexbox,
  color,
  (props) => ({ fill: props.fill, color: props.color, stroke: props.stroke, strokeWidth: props.strokeWidth }),
  {
    '.stroke': {
      fill: 'none',
      stroke: theme.colors.secondary[1],
      strokeMiterlimit: 10,
      strokeWidth: '1.4px',
    },
    '.stroke-canales': {
      fill: 'none',
      stroke: theme.colors.white,
      strokeMiterlimit: 10,
      strokeWidth: '1.96px',
    },
  }
);
SvgContainer.defaultProps = {
  display: 'block',
  alignItems: 'center',
  justifyContent: 'center',
};
